import { apiRemote } from '../../Services/RemoteService';

export const normalizeSettings = (settings) =>
  settings.reduce((normalizedSettings, settingsGroup) => {
    const { enable_property_referrals, ...partialSettings } = settingsGroup;

    const enable_cross_sell = enable_property_referrals;
    const normalizedSettingsGroup = {
      ...partialSettings,
      enable_cross_sell,
    };
    normalizedSettings.push(normalizedSettingsGroup);

    return normalizedSettings;
  }, []);

export const normalizeTodoPreferences = (todoPreferences) =>
  todoPreferences.map((preference) => ({
    todoRuleId: preference.todo_rule_id,
    description: preference.description,
    yellowThreshold: preference.yellow_threshold,
    redThreshold: preference.red_threshold,
  }));

export const normalizeLeasingTeamTodoPreferences = (
  leasingTeamTodoPreferences,
) =>
  leasingTeamTodoPreferences.reduce(
    (todoPreferencesByLeasingTeamId, leasingTeam) => {
      const { leasing_team_id, todo_preferences } = leasingTeam;

      todoPreferencesByLeasingTeamId[leasing_team_id] =
        normalizeTodoPreferences(todo_preferences || []);
      return todoPreferencesByLeasingTeamId;
    },
    {},
  );

export const transformTodoPreference = (preference) => ({
  todo_rule_id: preference.todoRuleId,
  yellow_threshold: preference.yellowThreshold,
  red_threshold: preference.redThreshold,
});

export const transformSettings = (settings) => {
  /***  express_sms_consent_override is not editable on the settings page ***/
  /***  but its presence in the update payload triggers a long running ***/
  /***  database process when in the payload ***/
  const {
    enable_cross_sell,
    // eslint-disable-next-line no-unused-vars
    express_sms_consent_override,
    ...partialSettings
  } = settings;
  return {
    ...partialSettings,
    enable_property_referrals: enable_cross_sell,
  };
};

class SettingsAPI {
  static async getSettings() {
    const response = await apiRemote.get(`admin/settings`);
    if (!response.ok || response.status !== 200) {
      throw new Error();
    }
    const responseBody = await response.json();

    return {
      ...responseBody,
      leasing_team_settings: normalizeSettings(
        responseBody.leasing_team_settings,
      ),
    };
  }

  static async getAllLeasingTeamTodoPreferences() {
    const response = await apiRemote.get('admin/settings/todo-preferences');

    if (!response.ok || response.status !== 200) {
      throw new Error();
    }

    const { leasing_team_todo_preferences } = await response.json();

    return normalizeLeasingTeamTodoPreferences(
      leasing_team_todo_preferences || [],
    );
  }

  static async updateLeasingTeamTodoPreferences(leasingTeamId, preference) {
    const transformedPreference = transformTodoPreference(preference);
    const payload = {
      leasing_team_todo_preferences: [transformedPreference],
    };
    const response = await apiRemote.post(
      `admin/settings/${leasingTeamId}/todo-preferences`,
      payload,
    );

    if (!response.ok || response.status !== 200) {
      throw new Error();
    }
  }

  static updateGroupSettings(groupId, updatedSettings) {
    const transformedSettings = transformSettings(updatedSettings);
    const payload = {
      ...transformedSettings,
      craigslist_template_id:
        transformedSettings.craigslist_settings.company_template_id,
      craigslist_reminder_frequency:
        transformedSettings.craigslist_settings.reminder_frequency,
    };
    return apiRemote
      .put(`admin/settings/${groupId}`, payload)
      .then((response) => response.json());
  }
}

export default SettingsAPI;
